import { getSyncDb, SyncRequest } from "../sync_db_manager";

export class IndexedDBSyncService {
    static request = {
        async add(request: SyncRequest){
            return await getSyncDb().request.addRequest(request);
        },
        async getAll(): Promise<SyncRequest[]>{
            return await getSyncDb().request.getAllRequests();
        },
        async deleteRequest(id: string){
            return await getSyncDb().request.deleteRequest(id);
        },
        async deleteAll(){
            return await getSyncDb().request.deleteAll();
        }
    }
}